import PageAbstract from '../PageAbastract'
import store from '@/store'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { RATE_TYPE, CARGO_SOURCES, TAX_NATURES } from '@/class/cargo/model/parameters/SystemConstants'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache } from '@/utils/cacheManager'
import { Company } from '@/class/model/mdm/Company'
import { getObjectByCache, getSpecificBasicDataFromCache } from '@/utils/basicDataCache'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { User } from '@/class/model/sys/User'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import { Office } from '@/class/model/sys/Office'
import * as WarehouseInState from '@/class/cargo/model/parameters/WarehouseInState'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import lang from '@/lang'
import { queryAirlineProductDownList } from '@/api/booking/airlineProduct'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import { OverseaAgent } from '@/class/model/sys/OverseaAgent'

const isZh = store.getters.language === 'zh'

export default class AirBookingBasic extends PageAbstract {
  constructor(job, formData) {
    super(job, formData)
    this.isHC = String(cache.config.get('ToExoSystem')) === 'HC'
    this.openProjectConfig = Number(cache.config.get('openProjectConfig')) === 1
    this.isProjectLinkedCustomer = Number(cache.config.get('isProjectLinkedCustomer')) === 1
    this.salesOfficeCheck = Number(cache.config.get('SalesOfficeCheck')) === 1
    this.isSpecifiedSalesBusiness = Number(cache.config.get('IsSpecifiedSalesBusiness')) === 1
    this.overseaAgentUsersConfig = Number(cache.config.get('overseaAgentUsersConfig'))
    this.editMawblNoMode = Number(cache.config.get('EditMawblNoMode'))
    this.aeAllowInputMBL = Number(cache.config.get('AEAllowInputMBL')) === 1
    this.splitBubbleCollectionFormat = Number(cache.config.get('SplitBubbleCollectionFormat')) === 1
  }

  async loadElement(elementName) {
    let e = null
    switch (elementName) {
      case 'carrierId': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoCompanySelect'))?.default,
          props: {
            no: elementName,
            methodParams: { companyLob: 'airExport', airCmp: true, active: true }
          },
          convertValue: value => value || 0
        }
        break
      }
      case 'bookingAgent': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          props: {
            no: elementName,
            selectType: TYPE_NAMES.basic_data_Company,
            methodParams: { bookingAgent: true, active: true },
            filterable: true,
            staticOptions: null
          },
          convertValue: value => value || 0
        }
        break
      }
      case 'rateType':
        e = {
          elementName,
          component: (await import('@/components/uiCustom/cargoSelect'))?.default,
          props: {
            no: elementName,
            options: [...RATE_TYPE],
            labelField: isZh ? 'chineseName' : 'englishName',
            valueField: 'code'
          }
        }
        break
      case 'vesselLine': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        const callback = () => this.takeOutVesselLine()
        this.joinFieldWatchList('destinationPortCode', callback)
        callback()
        break
      }
      case 'cargoSource': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/cargoSelect'))?.default,
          props: {
            no: elementName,
            options: [...CARGO_SOURCES],
            labelField: isZh ? 'chineseName' : 'englishName',
            valueField: 'code'
          },
          linkCheckItems: [{ pageType: UICustomConstants.AIR_BOOKING_BASIC, elementName: 'designationAgent' }]
        }
        break
      }
      case 'cargoType': {
        const cargoType4JobSelect = getSpecificBasicDataFromCache(TYPE_NAMES.basic_data_CargoType).filter(p => p.air)
        e = {
          elementName,
          component: (await import('@/components/uiCustom/cargoSelect'))?.default,
          props: {
            no: elementName,
            options: cargoType4JobSelect,
            labelField: isZh ? 'chineseName' : 'englishName',
            valueField: 'code'
          }
        }
        break
      }
      case 'customJobType': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          props: {
            no: elementName,
            selectType: TYPE_NAMES.basic_data_CutomJobType,
            methodParams: { type: 'AE' },
            filterable: true
          }
        }
        break
      }
      case 'secondaryCustomJobType': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          hide: true,
          props: {
            no: elementName,
            selectType: TYPE_NAMES.basic_data_CutomJobType,
            cache: false,
            filterable: true,
            staticOptions: []
          }
        }
        const callback = () => this.setSecondaryCustomJobTypeFunc(e)
        this.joinFieldWatchList('customJobType', callback)
        callback()
        break
      }
      case 'poNo': {
        e = {
          elementName,
          props: {
            no: elementName
          }
        }
        if (this.openProjectConfig) {
          e.component = (await import('@/components/Cargo/Common/cargoProjectSelect'))?.default
          e.props.isLinked = this.isProjectLinkedCustomer
          const callback = () => { e.props.customerId = this.job.customerId }
          this.joinFieldWatchList('customerId', callback)
          callback()
        } else {
          e.component = 'el-input'
        }
        break
      }
      case 'projectName': {
        e = {
          elementName,
          component: 'el-input',
          hide: !this.openProjectConfig,
          disabled: true,
          props: {}
        }
        break
      }
      case 'projectBatch': {
        e = {
          elementName,
          component: 'el-input',
          hide: !this.openProjectConfig,
          props: {
            no: elementName
          }
        }
        break
      }
      case 'portOfDestinationServices': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/ae/basic/portOfDestinationServices'))?.default,
          props: {}
        }
        const jobCallback = () => { e.props.job = this.job }
        this.joinJobWatchList(jobCallback)
        jobCallback()
        break
      }
      case 'sales': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/ae/sales'))?.default,
          props: {
            no: elementName,
            methodParams: { officeId: this.salesOfficeCheck ? store.getters.currentOfficeId : '', category: 'role', shape: 'sales', active: true }
          },
          convertValue: value => value || 0
        }
        const jobCallback = () => { e.props.job = this.job }
        const callback = async() => {
          e.props.staticOptions = null
          if (this.job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code && this.isSpecifiedSalesBusiness) {
            const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.job.customerId)
            if (company) {
              const salesList = []
              // 如果开启分公司过滤参数，查出来所有分公司
              let officeSaleList
              if (this.salesOfficeCheck) {
                officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', store.getters.currentOfficeId)
              }
              officeSaleList = officeSaleList || []
              const companyUsers = await Company.getCompanyUsers(company.uuid)
              if (companyUsers && companyUsers.length > 0) {
                for (const u of companyUsers) {
                  const userValid = this.job.fba ? u.lob === SystemConstants.FBA_SE.code : u.lob === this.job.lob
                  if (!u.lob || userValid || u.lob === 'ALL') {
                    const user = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', u.userId)
                    if (user && user.active) {
                      if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
                        if (this.salesOfficeCheck) {
                          for (const obj of officeSaleList) {
                            if (user.userId === obj.userId) {
                              salesList.push(user)
                            }
                          }
                        } else {
                          salesList.push(user)
                        }
                      }
                    }
                  }
                }
              }
              e.props.staticOptions = salesList
            }
          }
        }
        this.joinJobWatchList(jobCallback)
        this.joinFieldWatchList('cargoSource', callback)
        this.joinFieldWatchList('customerId', callback)
        jobCallback()
        await callback()
        break
      }
      case 'overseaOp': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoUserSelect'))?.default,
          props: {
            no: elementName,
            methodParams: { category: 'role', shape: 'overseaOp' }
          },
          convertValue: value => value || 0
        }
        const jobCallback = () => { e.props.job = this.job }
        const callback = async() => {
          if (this.isHC) {
            e.props.staticOptions = null
          } else {
            let cmpIdx = 0
            if (this.job.cargoSource === CargoSource.NC_CARGO_SOURCE.code) {
              cmpIdx = this.job.designationAgent // 根据指定货确定海外客服
            } else {
              cmpIdx = this.job.destinationAgent // 还是根据目的港代理确定海外客服
            }
            const cmp = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', cmpIdx)
            const overseaAgentDetail = cmp ? await new Company(cmp).getOverseaAgentDetail() : null
            if (overseaAgentDetail) {
              const overseaAgentUsers = await new OverseaAgent(overseaAgentDetail).getOverseaAgentUserList()
              const overseaAgentUsersList = []
              if (overseaAgentUsers && overseaAgentUsers.length > 0) {
                for (const u of overseaAgentUsers) {
                  if (u.lob === this.job.lob || !u.lob || u.lob === 'ALL') {
                    const user = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', u.userId)
                    if (user && user.active) {
                      if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
                        overseaAgentUsersList.push(user)
                      }
                    }
                  }
                }
              }
              e.props.staticOptions = overseaAgentUsersList
            } else {
              if (this.overseaAgentUsersConfig === 1) {
                e.props.staticOptions = null
              } else {
                e.props.staticOptions = []
              }
            }
            if (!e.props.staticOptions || e.props.staticOptions.length === 0) {
              if (this.overseaAgentUsersConfig === 1) {
                e.props.staticOptions = null
              } else {
                e.props.staticOptions = []
              }
            }
          }
        }
        this.joinJobWatchList(jobCallback)
        this.joinFieldWatchList('cargoSource', callback)
        jobCallback()
        await callback()
        break
      }
      case 'txtSalesOffice': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        const callback = async() => {
          const office = await Office.getOfficeById(this.job.salesOffice)
          if (office) {
            this.job.txtSalesOffice = isZh ? office.chineseName : office.englishName
          } else {
            this.job.txtSalesOffice = ''
          }
        }
        this.joinFieldWatchList('salesOffice', callback)
        await callback()
        break
      }
      case 'taxNature': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/cargoSelect'))?.default,
          props: {
            no: elementName,
            options: TAX_NATURES,
            labelField: isZh ? 'chineseName' : 'englishName',
            valueField: 'code'
          }
        }
        break
      }
      case 'satisfiedRequests': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/ae/basic/specialRequestsGrid'))?.default,
          props: {}
        }
        const jobCallback = () => { e.props.job = this.job }
        const callback = () => { e.props.customerId = this.job.customerId }
        this.joinJobWatchList(jobCallback)
        this.joinFieldWatchList('customerId', callback)
        jobCallback()
        callback()
        break
      }
      case 'salesChannel': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'trustFromJob': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'relatedJob': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'quotationNo': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'warehouseStatus': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/cargoSelect'))?.default,
          disabled: true,
          props: {
            no: elementName,
            options: WarehouseInState.WAREHOUSE_STATE,
            labelField: isZh ? 'chineseName' : 'englishName',
            valueField: 'code'
          }
        }
        break
      }
      case 'plannerOffice': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoOfficeSelect'))?.default,
          disabled: true,
          props: {
            no: elementName
          }
        }
        break
      }
      case 'csrOffice': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoOfficeSelect'))?.default,
          disabled: true,
          props: {
            no: elementName
          }
        }
        break
      }
      case 'dcOffice': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoOfficeSelect'))?.default,
          disabled: true,
          props: {
            no: elementName
          }
        }
        break
      }
      case 'cargoSalesId': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoUserSelect'))?.default,
          props: {
            no: elementName,
            methodParams: { category: 'role', shape: 'salesOfGoods' }
          },
          convertValue: value => value || 0
        }
        const callback = async() => {
          e.props.staticOptions = null
          if (this.isSpecifiedSalesBusiness) {
            const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.job.customerId)
            if (company) {
              const cargoSalesList = []
              const companyUsers = await Company.getCompanyUsers(company.uuid)
              if (companyUsers && companyUsers.length > 0) {
                for (const u of companyUsers) {
                  if (!u.lob || u.lob === this.job.lob || u.lob === 'ALL') {
                    const user = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', u.userId)
                    if (user) {
                      if (u.roleType === CargoOfRoleType.SALES_OF_GOODS.code) { // 揽货销售
                        cargoSalesList.push(user)
                      }
                    }
                  }
                }
              }
              if (cargoSalesList.length > 0) {
                e.props.staticOptions = cargoSalesList
              }
            }
          }
        }
        this.joinFieldWatchList('customerId', callback)
        await callback()
        break
      }
      case 'designationAgent': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          props: {
            no: elementName,
            selectType: TYPE_NAMES.basic_data_Company,
            methodParams: { designationAgent: true, active: true },
            fields: ['englishName'],
            tagName: 'englishName',
            filterable: true
          },
          convertValue: value => value || 0
        }
        const callback = () => {
          e.hide = this.job.cargoSource !== 'NC'
        }
        this.joinFieldWatchList('cargoSource', callback)
        callback()
        break
      }
      case 'boardSales': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'boardCsr': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'boardSite': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'exportControlledProduct': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/cargoSelect'))?.default,
          props: {
            no: elementName,
            options: SystemConstants.EXPORT_CONTROLLED_PRODUCT,
            labelField: isZh ? 'chineseName' : 'englishName',
            valueField: 'code',
            clearable: true,
            placeholder: lang.t('SeaExport.PleaseSelect')
          }
        }
        break
      }
      case 'arrivalMethod': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/cargoSelect'))?.default,
          disabled: true,
          props: {
            no: elementName,
            options: AirExportConstants.ARRIVAL_METHOD,
            labelField: isZh ? 'chineseName' : 'englishName',
            valueField: 'code',
            clearable: true,
            placeholder: lang.t('SeaExport.PleaseSelect')
          }
        }
        break
      }
      case 'flightLabel': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/cargoSelect'))?.default,
          disabled: true,
          props: {
            no: elementName,
            options: AirExportConstants.AIR_FLIGHT_LABEL,
            labelField: isZh ? 'chineseName' : 'englishName',
            valueField: 'code',
            clearable: true,
            placeholder: lang.t('SeaExport.PleaseSelect')
          }
        }
        break
      }
      case 'warehouseInDate': {
        e = {
          elementName,
          component: 'el-date-picker',
          disabled: true,
          props: {
            no: elementName,
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss'
          }
        }
        break
      }
      case 'warehouseOutDate': {
        e = {
          elementName,
          component: 'el-date-picker',
          disabled: true,
          props: {
            no: elementName,
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss'
          }
        }
        break
      }
      case 'channelNo': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'airlineProductUuid': {
        // 初始化 航线产品下拉列表
        const airlineProductDownList = await queryAirlineProductDownList({ containVoyage: false, branchId: store.getters.currentOfficeId }).then(res => res.data)
        e = {
          elementName,
          component: (await import('@/components/standard/cargoAdvanceSelect'))?.default,
          props: {
            no: elementName,
            filterable: true,
            methodParams: { active: true },
            tagValue: 'uuid',
            tagName: 'name',
            filterTagNames: ['name'],
            staticOptions: airlineProductDownList
          }
        }
        break
      }
      case 'transfering': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/ae/basic/transfering'))?.default,
          props: {}
        }
        const jobCallback = () => { e.props.job = this.job }
        this.joinJobWatchList(jobCallback)
        jobCallback()
        break
      }
      case 'mbl': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/ae/basic/mbl'))?.default,
          props: {}
        }
        const jobCallback = () => { e.props.job = this.job }
        const callback = () => {
          let mblEnabled = !this.job.express && (this.job.bookingTerm === BookingTerm.DB_BOOKING_TYPE.code || this.job.bookingTerm === BookingTerm.CB_BOOKING_TYPE.code)
          if (!mblEnabled) {
            mblEnabled = this.job.express ? true : this.aeAllowInputMBL && !this.job.lclMasterUuid
          }
          e.props.isEditablemawbNoInput = !(mblEnabled && (this.editMawblNoMode === 0 || !(this.editMawblNoMode === 1 && this.job.bookingTerm === BookingTerm.SB_BOOKING_TYPE.code)))
        }
        this.joinJobWatchList(jobCallback)
        this.joinFieldWatchList('express', callback)
        this.joinFieldWatchList('bookingTerm', callback)
        this.joinFieldWatchList('lclMasterUuid', callback)
        jobCallback()
        callback()
        break
      }
      case 'jobSoNo': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/ae/basic/jobSoNo'))?.default,
          props: {}
        }
        const jobCallback = () => { e.props.job = this.job }
        this.joinJobWatchList(jobCallback)
        jobCallback()
        break
      }
      case 'pbProportion':
      case 'pbProportion2': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/ae/basic/pbProportion'))?.default,
          props: {
            splitBubbleCollectionFormat: this.splitBubbleCollectionFormat
          },
          convertValue: value => value || 0
        }
        break
      }
      case 'exChangeAgent': {
        e = {
          elementName,
          component: (await import('@/components/standard/cargoCompanySelect'))?.default,
          props: {
            no: elementName,
            methodParams: { bookingAgent: true, active: true }
          },
          convertValue: value => value || 0
        }
        const callback = () => { e.disabled = !this.job.dischargingPortDoor }
        this.joinFieldWatchList('dischargingPortDoor', callback)
        callback()
        break
      }
      case 'estimatedDateOfWarehousinge': {
        e = {
          elementName,
          component: 'el-date-picker',
          props: {
            no: elementName,
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss'
          }
        }
        break
      }
      case 'estimatedDeliveryTime': {
        e = {
          elementName,
          component: 'el-date-picker',
          props: {
            no: elementName,
            type: 'datetime',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss'
          }
        }
        break
      }
      case 'estimatedDeliveryDate': {
        e = {
          elementName,
          component: 'el-date-picker',
          props: {
            no: elementName
          }
        }
        const callback = () => { e.disabled = !this.job.cargoTerminalOperation }
        this.joinFieldWatchList('cargoTerminalOperation', callback)
        callback()
        break
      }
      case 'measurements': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/ae/basic/measurements'))?.default,
          props: {
            type: 'textarea',
            rows: 3
          }
        }
        const jobCallback = () => { e.props.job = this.job }
        this.joinJobWatchList(jobCallback)
        jobCallback()
        break
      }
    }
    if (e) {
      this.elementMap.set(elementName, e)
    }
    return e
  }

  // 根据卸货港带出航线
  takeOutVesselLine() {
    this.job.vesselLine = ''
    if (this.job.destinationPortCode) {
      const port = getObjectByCache(TYPE_NAMES.basic_data_Airport, 'code', this.job.destinationPortCode)
      if (port) {
        const region = getObjectByCache(TYPE_NAMES.basic_data_Region, 'code', port.region)
        this.job.vesselLine = region ? (isZh ? region.name : region.nameEnglish) : ''
      }
    }
  }

  setSecondaryCustomJobTypeFunc(e) {
    if (this.job.customJobType) {
      e.props.staticOptions = JobUtils.setSecondaryCustomJobTypeList(this.job.customJobType, this.job.lob)
    } else {
      e.props.staticOptions = []
    }
    e.hide = !this.job.customJobType || e.props.staticOptions.length === 0
  }
}
